module.exports = __webpack_public_path__ + "static/media/input.d24d0313.svg";